<li  [ngClass]="{ active: isActiveState(), minimized: isMinimized() }" class="list-item">
  <div [ngClass]="{ active: isActiveState() }" class="list-item__wrapper">
    <button
      #trigger="cdkOverlayOrigin"
      (click)="onHandleClick()"
      (mouseenter)="onMouseEnterInButton(listItem().children)"
      [class.open]="subItemsPopupOpen()"
      [ngClass]="{ active: isActiveState(), minimized: isMinimized() }"
      cdkOverlayOrigin
      class="list-item__button"
    >
      <div class="list-item__content">
        <div class="list-item__icon">
          <app-icon [color]="'var(--blue-text)'" [iconName]="listItem().icon"/>
        </div>
        <span [ngClass]="{ minimized: isMinimized() }" class="list-item__title">
          {{ listItem().header | translate }}
        </span>
      </div>
      <div [ngClass]="{ active: listItem().expanded, minimized: isMinimized() }" class="list-item__arrow">
        <app-icon [color]="listItem().expanded ? 'var(--blue-text)' : 'var(--base-text-color)'" [iconName]="['Arrows', 'down']"/>
      </div>
    </button>
  </div>
  @if (listItem().children && !isMinimized()) {
    <app-sub-list-nav-bar [expanded]="listItem().expanded" [subItems]="listItem().children ?? []" />
    @if (listItem().expanded) {
      <span class="separator"></span>
    }
  }
</li>

<ng-template
  (overlayOutsideClick)="closeSubItemsPopup()"
  [cdkConnectedOverlayHasBackdrop]="false"
  [cdkConnectedOverlayOpen]="subItemsPopupOpen()"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="10"
  cdkConnectedOverlay
>
  <div @popup2>
    <app-popup-minimized-nav-bar [subItems]="subItemsForPopup()" [titleSubItems]="listItem().header"/>
  </div>
</ng-template>
